import React, { Component } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Switch,
  TextField,
  Typography,
  colors
} from "@material-ui/core";
import { toast } from "react-toastify";
import axios from "axios";
import _apiData from "../../metaData";
let apiData = _apiData[0];
console.log(apiData, "apiData");

export default class EditClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appName: "",
      password: "",
      agentRole: "",
      searchText: "Search",
      searchData: {},
      showDetails: false
    };
  }

  componentDidMount() {
    if(this.props.location.state && this.props.location.state.email){
      axios
        .get(apiData.userDetails.url, {
          params: { username: this.props.location.state.email },
          headers: apiData.headers
        })
        .then(res => {
          console.log(res, "ress");
          this.setState({
            searchText: "Search"
          });
          if (res.data.ok) {
            console.log(res.data.response.userObj, "res.dataoop");
            let response = res.data.response.userObj;
            let showObj = {};
            showObj.mobile = response.primary_phone
              ? response.primary_phone
              : "-";
            showObj.email = response.email ? response.email : "-";
            showObj.firstName = response.first_name;
            showObj.lastName = response.last_name;
            showObj.userType = response.user_type;
            showObj.userName = response.username;
            showObj.clientName = response.client_name
              ? response.client_name
              : "-";
            // showObj.apps = response.assigned_apps;
            showObj.projects = response.assigned_prefixCodes;
            console.log(showObj, "showObj");
            this.setState({
              searchData: showObj,
              showDetails: true
            });
          } else {
            this.setState({
              showDetails: false
            });
            toast.error(
              res.data.error.reason
                ? res.data.error.reason
                : "User Not Found !",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    }
  }

  submitAgent(e) {
    axios.put(apiData.add_client.url,{
      appName: this.state.appName,
      password: this.state.password,
      username: this.state.searchData.userName
    },{
      headers: apiData.headers
    })
    .then(res => {
      if(res.data.ok){
        toast.success("Client Edited Sucessfully", {
          position: toast.POSITION.TOP_RIGHT
        });
        this.setState({
          appName: "",
          password: ""
        })
      }
    })
    // if (!this.state.agentRole) {
    //   toast.error("Please Select Role!", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else {
    //   console.log("submit..");
    //   let data = {};
    //   data.username = this.state.searchData.userName;
    //   data.user_type = this.state.agentRole;
    //   axios
    //     .put(apiData.userDetails.url, data, {
    //       headers: apiData.headers
    //     })
    //     .then(res => {
    //       console.log(res, "submit put res");
    //       if (res.data.ok) {
    //         toast.success("Edited Sucessfully!", {
    //           position: toast.POSITION.TOP_RIGHT
    //         });
    //         this.setState({
    //           showDetails: false,
    //           agentRole: ""
    //         });
    //       } else {
    //         toast.error(
    //           res.data.error.reason
    //             ? res.data.error.reason
    //             : "User Not Found !",
    //           {
    //             position: toast.POSITION.TOP_RIGHT
    //           }
    //         );
    //       }
    //     });
    // }
  }
  searchClick(e) {
    console.log(this.state.searchMobile, "mobile");
    this.setState({
      searchText: "Loading..."
    });
    if (this.state.searchMobile) {
      let params = {};
      params.username = this.state.searchMobile;
      console.log(params, "paraaamss");
      axios
        .get(apiData.userDetails.url, {
          params: { username: this.state.searchMobile },
          headers: apiData.headers
        })
        .then(res => {
          console.log(res, "ress");
          this.setState({
            searchText: "Search"
          });
          if (res.data.ok) {
            console.log(res.data.response.userObj, "res.dataoop");
            let response = res.data.response.userObj;
            let showObj = {};
            showObj.mobile = response.primary_phone
              ? response.primary_phone
              : "-";
            showObj.email = response.email ? response.email : "-";
            showObj.firstName = response.first_name;
            showObj.lastName = response.last_name;
            showObj.userType = response.user_type;
            showObj.userName = response.username;
            showObj.clientName = response.client_name
              ? response.client_name
              : "-";
            // showObj.apps = response.assigned_apps;
            showObj.projects = response.assigned_prefixCodes;
            console.log(showObj, "showObj");
            this.setState({
              searchData: showObj,
              showDetails: true
            });
          } else {
            this.setState({
              showDetails: false
            });
            toast.error(
              res.data.error.reason
                ? res.data.error.reason
                : "User Not Found !",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    } else {
      toast.error("Please Enter Mobile/UserName !", {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  render() {
    console.log(this.state.agentRole, "agentRole");
    return (
      <div className="container hole-container" style={{ width: "76em" }}>
        <h6 className="page-header">Edit Client</h6>

        <div className="row data-row">
          <div className="col-md-3 label-class">
            <span className="label-text">Email</span>
          </div>
          <div className="col-md-7 select-bordered-div">
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                // type="number"
                // label="Select State"
                name="state"
                label="Email"
                onChange={e => {
                  this.setState({ searchMobile: e.target.value });
                }}
                // select
                // eslint-disable-next-line react/jsx-sort-props
                // SelectProps={{ native: true }}
                // value={values.state}
                variant="outlined"
              ></TextField>
            </Grid>
          </div>
          <div className="col-md-2" id="search-btn">
            <Button
              variant="contained"
              color="primary"
              component="span"
              onClick={this.searchClick.bind(this)}
            >
              {this.state.searchText}
            </Button>
          </div>
        </div>
        {this.state.showDetails ? (
          <form className="form-style" id="dataForm">
            <div className="row data-row">
              <div className="col-md-2 label-class"></div>
              <div className="col-md-1 label-class"></div>
              <div className="col-md-8 select-bordered-div">
                <table class="table">
                  {/* <thead>
                  <tr>
                    <th scope="col">First</th>
                    <th scope="col">Last</th>
                  </tr>
                </thead> */}
                  <tbody>
                    <tr>
                      <td>Mobile</td>
                      <td>{this.state.searchData.mobile}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{this.state.searchData.email}</td>
                    </tr>
                    <tr>
                      <td>First Name</td>
                      <td>{this.state.searchData.firstName}</td>
                    </tr>
                    <tr>
                      <td>Last Name</td>
                      <td>{this.state.searchData.lastName}</td>
                    </tr>
                    <tr>
                      <td>User Name</td>
                      <td>{this.state.searchData.userName}</td>
                    </tr>
                    <tr>
                      <td>User Type</td>
                      <td>{this.state.searchData.userType}</td>
                    </tr>
                    <tr>
                      <td>Client Name</td>
                      <td>{this.state.searchData.clientName}</td>
                    </tr>
                    {/* <tr>
                      <td>Apps List</td>
                      <td>
                        {this.state.searchData.apps.map(app => {
                          return <span>{app},&nbsp;</span>;
                        })}
                      </td>
                    </tr> */}
                    <tr>
                      <td>Assigned Projects</td>
                      <td>
                        {this.state.searchData.projects.map(proj => {
                          return <span>{proj},&nbsp;</span>;
                        })}
                      </td>{" "}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-md-1 label-class"></div>
            </div>

            <div className="row data-row">
              <div className="col-md-2 label-class">
                <span className="label-text">Agency Name</span>
              </div>
              <div className="col-md-10 select-bordered-div">
                <Grid item md={12} xs={12}>
                  <TextField
                    fullWidth
                    // type="number"
                    // label="Select State"
                    name="state"
                    label="AppName"
                    onChange={e => {
                      this.setState({ appName: e.target.value });
                    }}
                    // select
                    // eslint-disable-next-line react/jsx-sort-props
                    // SelectProps={{ native: true }}
                    value={this.state.appName}
                    variant="outlined"
                  ></TextField>
                </Grid>
              </div>
            </div>

            <div className="row data-row">
              <div className="col-md-2 label-class">
                <span className="label-text">Password</span>
              </div>
              <div className="col-md-10 select-bordered-div">
                <Grid item md={12} xs={12}>
                  <TextField
                    fullWidth
                    name="state"
                    label="Password"
                    type="password"
                    onChange={e => {
                      this.setState({ password: e.target.value });
                    }}
                    value={this.state.password}
                    variant="outlined"
                  ></TextField>
                </Grid>
              </div>
            </div>

            <div className="row">
              <div className="col-md-10"></div>
              <div className="col-md-2">
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  onClick={this.submitAgent.bind(this)}
                >
                  Submit
                </Button>
              </div>
            </div>
          </form>
        ) : (
          ""
        )}
      </div>
    );
  }
}
